//////LIBRARY//////
import React from 'react'
import styled from 'styled-components'
import { replace } from 'lodash'
//////COMPONENTS//////
import theme from '../../../../theme/theme'
import convertHexToRGBA from '../../../../helpers/HexToRgba'

//////STYLED//////
const Wrapper = styled.div`
	display: flex;
	font-size: 14px;
`
const BlockConsignment = styled.div`
	flex: 2;
`
const TitleConsignment = styled.div`
	margin-block-start: 0em;
	margin-block-end: 0em;
	margin-inline-start: 0px;
	margin-inline-end: 0px;
	text-align: left;
	color: ${theme.colors.wedealBlueOther};
	flex: 1;
`
const PriceConsignment = styled.div`
	margin-block-start: 0em;
	margin-block-end: 0em;
	margin-inline-start: 0px;
	margin-inline-end: 0px;
	text-align: center;
	color: ${(props) => props.color};
	font-weight: ${(props) => props.type == 'actualPrice' && 'bold'} ${(props) => props.type == 'oldPrice' && 'normal'};
	text-decoration: ${(props) => props.type == 'actualPrice' && 'none'} ${(props) => props.type == 'oldPrice' && 'line-through'};
	flex: 1;

	width: fit-content;
	border-radius: 15px;
	background-color: ${theme.colors.white};

	margin: auto auto auto 0px;
	border: ${(props) => props.type == 'actualPrice' && '1px solid'} ${(props) => props.color};
	padding: ${(props) => (props.type == 'actualPrice' ? '0px 10px' : ' 0px 0px 0px 7px')};
	line-height: 25px;
	max-width: 45px;
`
const EmptyBlock = styled.div`
	flex: 1;
	color: white;
`
//////STYLED//////

const ItemCatalogDetailConsignment = ({ ItemDetail, translations }) => {
	/////////////////////////////// RENDER //////////////////////////////////////

	return (
		<Wrapper>
			{ItemDetail?.promo ? (
				<>
					<BlockConsignment>
						<TitleConsignment>{translations['page__itemCatalog__kiosk__field_deposit']}</TitleConsignment>
						<PriceConsignment type="actualPrice" color={theme.colors.wedealBlueOther}>
							{replace(ItemDetail?.promoDeposit.toFixed(2), '.', ',')}
							{ItemDetail?.currency?.symbol}
						</PriceConsignment>
					</BlockConsignment>
					<BlockConsignment>
						<EmptyBlock>-</EmptyBlock>
						<PriceConsignment type="oldPrice" color={theme.text.colors.primary}>
							{replace(ItemDetail?.depositPrice.toFixed(2), '.', ',')}
							{ItemDetail?.currency?.symbol}
						</PriceConsignment>
					</BlockConsignment>
				</>
			) : (
				<BlockConsignment>
					<TitleConsignment>{translations['page__itemCatalog__kiosk__field_deposit']}</TitleConsignment>
					<PriceConsignment type="actualPrice" color={theme.colors.wedealBlueOther}>
						{replace(ItemDetail?.depositPrice.toFixed(2), '.', ',')}
						{ItemDetail?.currency?.symbol}
					</PriceConsignment>
				</BlockConsignment>
			)}
		</Wrapper>
	)
}

export default ItemCatalogDetailConsignment
